import RegisterUploadResume from './RegisterUploadResume.react'

export default RegisterUploadResume